import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unique'
})
export class UniquePipe implements PipeTransform {

    transform<T>(items: T[]): T[] {
        return items?.filter((element, index, array) => this.onlyUnique(element, index, array));
    }

    private onlyUnique<T>(value: T, index: number, self: T[]) {
        return self.indexOf(value) === index;
    }
}
